"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledMessage = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _shared = require("../../shared");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const StyledMessage = _styledComponents.default.div.withConfig({
  displayName: "Errorstyle__StyledMessage",
  componentId: "sc-93ts07-0"
})(["", ";color:", ";"], _shared.theme.typography.caption.css, _shared.theme.palette.ui.cta.red);

exports.StyledMessage = StyledMessage;